<div class="places-autocomplete">
  <div class="input-wrapper">
    <!-- Icon slot (left) -->
    <div *ngIf="hasIcon && iconPosition === 'left'" class="input-icon input-icon-left">
      <ng-content select="[slot=icon-left]"></ng-content>
    </div>

    <input
      #autocompleteInput
      type="text"
      class="form-control"
      [class.has-icon-left]="hasIcon && iconPosition === 'left'"
      [placeholder]="placeholder"
      [disabled]="disabled || isLoading"
      [(ngModel)]="inputValue"
      (ngModelChange)="onInputChange()"
      autocomplete="off"
    />
    <button
      *ngIf="hasAddress && showRadiusSelector"
      class="radius-badge"
      type="button"
      (click)="openRadiusModal()">
      <i class="fas fa-location-arrow"></i>
      {{ radius }} km
    </button>
    <button
      *ngIf="inputValue && !disabled"
      type="button"
      class="clear-button"
      (click)="clearInput()"
      aria-label="Clear input"
    >
      ×
    </button>
  </div>

  <div *ngIf="isLoading" class="loading-message">
    Loading Google Maps...
  </div>

  <div *ngIf="error" class="error-message">
    {{ error }}
  </div>
</div>

<!-- Radius Modal -->
<div class="radius-modal-overlay" *ngIf="isRadiusModalOpen" (click)="closeRadiusModal()">
  <div class="radius-modal" (click)="$event.stopPropagation()">
    <div class="radius-modal__header">
      <h3>Search Radius</h3>
      <button class="radius-modal__close" (click)="closeRadiusModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="radius-modal__body">
      <div class="radius-slider">
        <label class="radius-slider__label">
          <span class="radius-slider__value">{{ tempRadius }} km</span>
          <input
            type="range"
            min="1"
            max="50"
            step="1"
            [value]="tempRadius"
            (input)="onRadiusInput($event)"
            class="radius-slider__input">
          <div class="radius-slider__labels">
            <span>1 km</span>
            <span>50 km</span>
          </div>
        </label>
      </div>
    </div>
    <div class="radius-modal__footer">
      <button class="btn btn-primary" (click)="applyRadius()">
        Apply
      </button>
    </div>
  </div>
</div>
